import { render, staticRenderFns } from "./BillsReceiptsTable.vue?vue&type=template&id=486590a5"
import script from "./BillsReceiptsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BillsReceiptsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports